/* Rince — 3D Badkamer (LINE-ART). Een volledige badkamer als architecturale
   lijntekening — lichte lijnen op de donkere Rince-achtergrond — gebaseerd op een
   referentie-blauwdruk: wastafelmeubel + spiegels, ligbad + raam, glazen douche met
   tegelwand + afvoerput, plankenvloer en inbouwspots. Roteerbaar (sleep), met/zonder-
   toggle (schone blauwe waterstraal vs neutraal) en hotspots. Three.js lazy-geladen.
   Drop-in: gebruikt dezelfde DOM-hooks als rince-bathroom.js. */
(function () {
  var CDN = window.__RINCE_THREE_SRC || 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var p = null;
  /* PERFORMANCE: op mobiel pas laden na het load-event + idle, zodat de ~589 KB
     Three.js-bundel niet concurreert met FCP/LCP. Desktop laadt direct door. */
  function loadThree(){ if(window.THREE) return Promise.resolve(window.THREE); if(p) return p;
    p = new Promise(function(res,rej){
      var go = function(){ var s=document.createElement('script'); s.src=CDN; s.async=true; s.onload=function(){res(window.THREE);}; s.onerror=function(){rej(new Error('three'));}; document.head.appendChild(s); };
      if (window.__rinceDefer3D && window.__rinceWhenIdle) window.__rinceWhenIdle(go); else go();
    }); return p; }

  function build(TH, canvas, root){
    var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var mobile = (window.innerWidth||1024) < 700;
    var autoOn = root.getAttribute('data-bath-autoorbit') !== 'false';
    var renderer = new TH.WebGLRenderer({canvas:canvas, antialias:true, alpha:true});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio||1, mobile?1.5:2));
    renderer.setClearColor(0x000000,0);

    var scene = new TH.Scene();
    var camera = new TH.PerspectiveCamera(33,1,0.1,100);
    var lookAt = new TH.Vector3(0.1, 1.05, -0.9);
    if (mobile) { lookAt.set(1.25, 1.12, -0.6); }   // mobiel: richt op de glazen douche (rechts) zodat die zichtbaar is

    /* line materials — light ink on dark */
    var inkMat   = new TH.LineBasicMaterial({color:0xc4ccd3, transparent:true, opacity:0.55});  // primary edges
    var softMat  = new TH.LineBasicMaterial({color:0x8b949d, transparent:true, opacity:0.30});  // tiles / planks / faint
    var fineMat  = new TH.LineBasicMaterial({color:0x9aa3ac, transparent:true, opacity:0.20});  // dense mosaic
    var accent   = new TH.LineBasicMaterial({color:0x5c7a95, transparent:true, opacity:0.9});   // Rince steel accent
    var waterMat = new TH.LineDashedMaterial({color:0x8fa9c0, transparent:true, opacity:0.0, dashSize:0.30, gapSize:0.05});   // shower stream (toggled, dash-flow)

    var model = new TH.Group(); scene.add(model);

    /* ---------- helpers (all build in the XY plane, centred, then we orient them) ---------- */
    function boxEdges(w,h,d,mat){ return new TH.LineSegments(new TH.EdgesGeometry(new TH.BoxGeometry(w,h,d)), mat); }
    function rectGeo(w,h){ var hw=w/2,hh=h/2; return new TH.Float32BufferAttribute([-hw,-hh,0, hw,-hh,0, hw,-hh,0, hw,hh,0, hw,hh,0, -hw,hh,0, -hw,hh,0, -hw,-hh,0],3); }
    function rect(w,h,mat){ var g=new TH.BufferGeometry(); g.setAttribute('position',rectGeo(w,h)); return new TH.LineSegments(g,mat); }
    function grid(w,h,cols,rows,mat){ var hw=w/2,hh=h/2,pts=[],i;
      for(i=0;i<=cols;i++){ var x=-hw+w*i/cols; pts.push(x,-hh,0, x,hh,0); }
      for(i=0;i<=rows;i++){ var y=-hh+h*i/rows; pts.push(-hw,y,0, hw,y,0); }
      var g=new TH.BufferGeometry(); g.setAttribute('position',new TH.Float32BufferAttribute(pts,3)); return new TH.LineSegments(g,mat); }
    function ring(r,n,mat){ var pts=[],i; for(i=0;i<n;i++){var a=i/n*Math.PI*2; pts.push(Math.cos(a)*r,Math.sin(a)*r,0);} var g=new TH.BufferGeometry(); g.setAttribute('position',new TH.Float32BufferAttribute(pts,3)); return new TH.LineLoop(g,mat); }
    function add(obj,x,y,z,rx,ry){ obj.position.set(x,y,z); if(rx)obj.rotation.x=rx; if(ry)obj.rotation.y=ry; model.add(obj); return obj; }
    var PX=Math.PI/2;

    var W=6, D=4.2, H=2.7, zBack=-3, zFront=zBack+D, xL=-3, xR=3;

    /* ---------- shell: floor planks, walls, ceiling spots ---------- */
    add(grid(W, D, 14, 1, softMat), 0, 0.001, zBack+D/2, -PX, 0);                 // plank floor (lines along depth)
    add(rect(W, H, softMat), 0, H/2, zBack, 0, 0);                                 // back wall outline
    add(grid(W, H, 1, 1, softMat), 0, H/2, zBack, 0, 0);
    add(rect(D, H, softMat), xL, H/2, zBack+D/2, 0, PX);                            // left wall outline
    add(ring(0.16, 24, softMat), -1.1, H-0.002, -0.6, -PX, 0);                      // recessed spots
    add(ring(0.16, 24, softMat),  0.7, H-0.002, -1.5, -PX, 0);

    /* ---------- vanity (left wall): cabinet + counter + drawers + mirrors + art + items ---------- */
    add(boxEdges(0.62, 0.86, 2.3, inkMat), xL+0.33, 0.43, -1.35);                  // cabinet body
    add(boxEdges(0.74, 0.08, 2.46, inkMat), xL+0.34, 0.90, -1.35);                 // countertop slab
    add(grid(2.3, 0.86, 3, 2, inkMat), xL+0.625, 0.43, -1.35, 0, PX);              // drawer/door divisions (front face)
    // basin recess + tap
    add(rect(0.5,0.34,softMat), xL+0.34, 0.945, -1.05, -PX, 0);
    add(boxEdges(0.05,0.12,0.05,inkMat), xL+0.30, 1.0, -1.05);
    // two framed mirrors on the wall
    [ -2.0, -0.65 ].forEach(function(mz){ add(rect(0.66,0.92,inkMat), xL+0.02, 1.55, mz, 0, PX); add(rect(0.56,0.82,softMat), xL+0.03, 1.55, mz, 0, PX); });
    // framed art (rose) further along
    add(rect(0.5,0.66,inkMat), xL+0.02, 1.5, 0.55, 0, PX); add(rect(0.4,0.56,softMat), xL+0.03, 1.5, 0.55, 0, PX);
    add(ring(0.12,20,softMat), xL+0.04, 1.5, 0.55, 0, PX); add(ring(0.06,16,softMat), xL+0.04, 1.5, 0.55, 0, PX);
    // potted plant + bottles on the counter
    add(boxEdges(0.22,0.2,0.22,inkMat), xL+0.34, 1.04, -0.45);
    var leaf=new TH.Group(); [0,0.5,1,1.5,2].forEach(function(a){ var l=ring(0.16,14,softMat); l.scale.set(1,2.2,1); l.position.y=0.28; l.rotation.z=a; leaf.add(l); }); add(leaf, xL+0.34, 1.14, -0.45);
    add(boxEdges(0.08,0.26,0.08,inkMat), xL+0.30, 1.03, -1.7);
    add(boxEdges(0.07,0.2,0.07,inkMat),  xL+0.34, 1.0, -1.82);

    /* ---------- bathtub (centre-back) + window ---------- */
    add(boxEdges(2.0, 0.56, 0.86, inkMat), -0.35, 0.28, zBack+0.5);                // tub body
    add(rect(1.7,0.62,softMat), -0.35, 0.56, zBack+0.5, -PX, 0);                    // basin rim
    add(rect(1.8,1.0,inkMat), -0.35, 1.75, zBack+0.02, 0, 0);                       // window
    add(grid(1.8,1.0,2,1,softMat), -0.35, 1.75, zBack+0.02, 0, 0);

    /* ---------- glass shower (right): tiled walls, enclosure, door, floor, drain, head ---------- */
    add(grid(2.0, 2.3, 8, 22, fineMat), xR-0.02, 1.15, zBack+1.0, 0, PX);          // right wall mosaic (brick)
    add(grid(1.6, 2.3, 7, 22, fineMat), 2.2, 1.15, zBack+0.02, 0, 0);              // back wall (shower) mosaic
    add(grid(1.6, 2.0, 7, 7, softMat), 2.2, 0.004, zBack+1.0, -PX, 0);             // shower floor tiles
    // enclosure: side glass panel (along depth) + front panel + door
    add(rect(2.0, 2.2, inkMat), 1.4, 1.1, zBack+1.0, 0, PX);                        // side glass panel
    add(rect(1.6, 2.2, inkMat), 2.2, 1.1, zBack+2.0, 0, 0);                         // front glass + door plane
    add(rect(0.72, 2.0, inkMat), 1.9, 1.05, zBack+2.01, 0, 0);                      // door leaf
    add(boxEdges(0.04,0.34,0.04,accent), 2.27, 1.15, zBack+2.05);                   // door handle (accent)
    // drain in the shower floor
    var drain=new TH.Group(); drain.add(rect(0.34,0.34,inkMat)); var dg=grid(0.34,0.34,1,5,softMat); drain.add(dg); add(drain, 2.2, 0.006, zBack+1.0, -PX, 0);
    /* ---------- Rince douchekop (compact line-art model, handdouche in wandhouder) ---------- */
    var HEADX=2.58, HEADY=2.10, HEADZ=zBack+0.42;
    function oval(r, sy, n, mat){ var o=ring(r,n,mat); o.scale.set(1,sy,1); return o; }
    // steel: licht taps, kantelt van de kop-achterrand omhoog naar de wandbeugel
    var handle=new TH.Group(); handle.position.set(HEADX, HEADY, HEADZ-0.13); handle.rotation.x=-0.62;
    [[0.04,0.050],[0.16,0.046],[0.27,0.043]].forEach(function(rr){
      var hr=ring(rr[1],16,inkMat); hr.rotation.x=PX; hr.position.y=rr[0]; handle.add(hr); });
    [0.05,-0.05].forEach(function(x){
      var g=new TH.BufferGeometry();
      g.setAttribute('position', new TH.Float32BufferAttribute([x,0.02,0, x*0.86,0.30,0],3));
      handle.add(new TH.Line(g,inkMat)); });
    // knurl-grip: dichte ribbelringen aan het slang-einde (zoals het echte product)
    [0.31,0.335,0.36,0.385].forEach(function(y){
      var kr=ring(0.045,14,softMat); kr.rotation.x=PX; kr.position.y=y; handle.add(kr); });
    model.add(handle);
    add(boxEdges(0.10,0.08,0.10,inkMat), HEADX, 2.42, zBack+0.10);          // wandbeugel
    // doucheslang: hangt met een lichte boog van de beugel langs de wand omlaag
    (function(){ var pts=[], N=14;
      for(var i=0;i<=N;i++){ var t=i/N;
        pts.push(HEADX+0.05+Math.sin(t*Math.PI)*0.10, 2.36-t*1.15, zBack+0.07+Math.sin(t*Math.PI*0.9)*0.09); }
      var g=new TH.BufferGeometry(); g.setAttribute('position',new TH.Float32BufferAttribute(pts,3));
      var hose=new TH.Line(g,softMat); model.add(hose); })();
    add(oval(0.20,0.62,32,inkMat), HEADX, HEADY+0.055, HEADZ, -PX, 0);      // bovenrand behuizing
    add(oval(0.21,0.62,32,inkMat), HEADX, HEADY, HEADZ, -PX, 0);            // buitenrand (breedste punt)
    add(oval(0.20,0.62,32,softMat), HEADX, HEADY-0.045, HEADZ, -PX, 0);     // onderrand
    add(oval(0.155,0.60,28,accent), HEADX, HEADY-0.05, HEADZ, -PX, 0);      // sproeiring (steel accent)
    add(oval(0.085,0.55,24,inkMat), HEADX, HEADY+0.055, HEADZ, -PX, 0);     // holle kern boven
    add(oval(0.085,0.55,24,softMat), HEADX, HEADY-0.05, HEADZ, -PX, 0);     // holle kern onder
    // verticale zijribben die boven- en onderrand verbinden (opengewerkt silhouet)
    [0, Math.PI*0.5, Math.PI, Math.PI*1.5].forEach(function(a){
      var rx=Math.cos(a)*0.205, rz=Math.sin(a)*0.127;
      var rib=new TH.BufferGeometry();
      rib.setAttribute('position', new TH.Float32BufferAttribute([HEADX+rx,HEADY+0.055,HEADZ+rz, HEADX+rx,HEADY-0.045,HEADZ+rz],3));
      model.add(new TH.Line(rib, inkMat));
    });

    /* ---------- douchestraal — dichte, consistente bundel uit de sproeiring ---------- */
    var stream=new TH.Group(); var SW=[]; var flowT=0;
    var SN=18;
    for(var s=0;s<SN;s++){
      var a=s/SN*Math.PI*2;
      var sx=HEADX+Math.cos(a)*0.150, sz=HEADZ+Math.sin(a)*0.092;      // bron: op de sproeiring
      var ex=HEADX+Math.cos(a)*0.108, ez=HEADZ+Math.sin(a)*0.066;      // licht convergerend omlaag
      var seg=new TH.BufferGeometry();
      seg.setAttribute('position', new TH.Float32BufferAttribute([sx,HEADY-0.06,sz, ex,0.05,ez],3));
      var ln=new TH.Line(seg, waterMat); ln.computeLineDistances();
      ln.userData.len=ln.geometry.attributes.lineDistance.getX(1);
      ln.userData.off=(s*0.047)%0.12;   // eigen dash-fase per lijn: geen horizontale banden
      SW.push(ln); stream.add(ln);
    }
    add(oval(0.15,0.6,24,softMat), HEADX, 0.012, HEADZ, -PX, 0);       // impact-ellips op de vloer
    model.add(stream);

    /* ---------- state: t=1 Met Rince (clean blue stream), t=0 Zonder (faint neutral) ---------- */
    var target=1, cur=1, cBlue=new TH.Color(0x8fa9c0), cTan=new TH.Color(0xa3a3a3);
    function applyState(t){ var z=1-t;
      waterMat.opacity = 0.24 + t*0.5;                    // clearer with Rince
      waterMat.color.copy(cTan).lerp(cBlue, t);           // murky neutral ↔ clean blue
      accent.opacity = 0.35 + t*0.55;                     // shower accents brighten with Rince
    }

    /* ---------- hotspots ---------- */
    var hotEls = Array.prototype.slice.call(root.querySelectorAll('[data-bath-hot]'));
    var ANCH = {
      put:    new TH.Vector3(2.2, 0.1, zBack+1.0),
      tegels: new TH.Vector3(2.95, 1.5, zBack+1.1),
      glas:   new TH.Vector3(1.5, 1.3, zBack+1.7),
      water:  new TH.Vector3(2.58, 1.2, zBack+0.42)
    };
    var vv=new TH.Vector3();
    function projectHots(){ var w=canvas.clientWidth,h=canvas.clientHeight;
      hotEls.forEach(function(el){ var k=el.getAttribute('data-bath-hot'); var a=ANCH[k]; if(!a)return;
        vv.copy(a).project(camera); var x=(vv.x*.5+.5)*w, y=(-vv.y*.5+.5)*h;
        el.style.transform='translate('+x+'px,'+y+'px) translate(-50%,-50%)'; el.classList.toggle('on', vv.z<1); }); }

    /* ---------- camera + interaction ---------- */
    var orbit=0.52, odir=1, tiltA=0.0, dragging=false, pxv=0, pyv=0;
    canvas.addEventListener('pointerdown',function(e){ if(e.target.closest('[data-bath-hot]'))return; dragging=true; pxv=e.clientX; pyv=e.clientY; try{canvas.setPointerCapture(e.pointerId);}catch(_){} play(); }, {passive:true});
    canvas.addEventListener('pointermove',function(e){ if(!dragging)return; orbit+=(e.clientX-pxv)*0.006; tiltA+=(e.clientY-pyv)*0.004; tiltA=Math.max(-0.12,Math.min(0.4,tiltA)); pxv=e.clientX; pyv=e.clientY; }, {passive:true});
    canvas.addEventListener('pointerup',function(){ dragging=false; }, {passive:true});
    function resize(){ var w=canvas.clientWidth||1,h=canvas.clientHeight||1; renderer.setSize(w,h,false); camera.aspect=w/h; camera.updateProjectionMatrix(); }

    var R = mobile ? 10.2 : 8.2;
    function frame(){
      cur += (target-cur)*0.08; applyState(cur);
      if(!reduced){
        if(!dragging && autoOn){ orbit += odir*0.0004; if(orbit>0.78){orbit=0.78;odir=-1;} else if(orbit<0.32){orbit=0.32;odir=1;} }
        // dash-flow: verschuif het streeppatroon zodat de bundel rustig omlaag stroomt
        flowT+=0.05;
        for(var i=0;i<SW.length;i++){ var att=SW[i].geometry.attributes.lineDistance; var o2=SW[i].userData.off;
          att.setX(0,o2-flowT); att.setX(1,SW[i].userData.len+o2-flowT); att.needsUpdate=true; }
      }
      var ox=Math.sin(orbit), oz=Math.cos(orbit);
      camera.position.set(lookAt.x+ox*R*0.62, 1.7+tiltA*3, lookAt.z + oz*R); camera.lookAt(lookAt);
      renderer.render(scene,camera); projectHots();
    }

    var rafId=null, active=true;
    function settling(){ return Math.abs(target-cur)>0.002; }
    function tick(){ frame(); if(reduced && !dragging && !settling()){ rafId=null; return; } rafId=requestAnimationFrame(tick); }
    function play(){ if(active && rafId==null) rafId=requestAnimationFrame(tick); }
    function pause(){ if(rafId!=null){ cancelAnimationFrame(rafId); rafId=null; } }
    if('IntersectionObserver' in window){ new IntersectionObserver(function(es){ active=es[0].isIntersecting; if(active) play(); else pause(); },{rootMargin:'150px'}).observe(canvas); }
    document.addEventListener('visibilitychange', function(){ if(document.hidden) pause(); else play(); });
    var rT; window.addEventListener('resize', function(){ clearTimeout(rT); rT=setTimeout(function(){ resize(); play(); }, 150); }, {passive:true});
    resize(); applyState(1); cur=1; play(); canvas.classList.add('is-ready');

    return { resize:resize, setState:function(v){ target=v; play(); }, getState:function(){ return target; }, anchors:ANCH };
  }

  function init(root){
    if(root.dataset.bathInit) return; root.dataset.bathInit='1';
    var canvas=root.querySelector('[data-bath-canvas]'); var loader=root.querySelector('[data-bath-loader]');
    var toggle=root.querySelector('[data-bath-toggle]'); var hots=Array.prototype.slice.call(root.querySelectorAll('[data-bath-hot]')); var card=root.querySelector('[data-bath-card]');
    var points=Array.prototype.slice.call(root.querySelectorAll('[data-point-body]'));
    var bodyEl=card?card.querySelector('[data-card-body]'):null, stateEl=card?card.querySelector('[data-card-state]'):null;
    var activeEl=null;
    if(!canvas) return;
    function isZonder(){ return root.classList.contains('is-zonder'); }
    function bodyFor(el){ var z=el.getAttribute('data-body-zonder'), m=el.getAttribute('data-body-met'); return (isZonder()? (z||m) : (m||z)) || ''; }
    function renderCard(){ if(!card||!activeEl)return; if(bodyEl) bodyEl.textContent=bodyFor(activeEl); if(stateEl) stateEl.textContent=isZonder()?'Zonder filter':'Met Rince'; }
    function renderPoints(){ points.forEach(function(pt){ pt.textContent=bodyFor(pt); }); }
    loadThree().then(function(TH){
      var api=build(TH,canvas,root); if(loader) loader.classList.add('gone');
      if(toggle){ toggle.addEventListener('click', function(){ var next=api.getState()>0.5?0:1; api.setState(next); root.classList.toggle('is-zonder', next<0.5); toggle.querySelector('[data-bath-state]').textContent = next>0.5?'Met Rince':'Zonder filter'; renderCard(); renderPoints(); }); }
      function showCard(el){ if(!card)return; activeEl=el; card.querySelector('[data-card-idx]').textContent=el.getAttribute('data-idx')||''; card.querySelector('[data-card-title]').textContent=el.getAttribute('data-title')||''; renderCard(); card.classList.add('is-show'); hots.forEach(function(h){h.classList.remove('is-active');}); el.classList.add('is-active'); }
      hots.forEach(function(el){ el.addEventListener('click', function(e){ e.stopPropagation(); showCard(el); }); });
      var x=root.querySelector('[data-card-close]'); if(x) x.addEventListener('click', function(){ card.classList.remove('is-show'); activeEl=null; hots.forEach(function(h){h.classList.remove('is-active');}); });
    }).catch(function(){ if(loader) loader.classList.add('gone'); root.setAttribute('data-bath-failed',''); });
  }
  function arm(root){ function near(){ var r=root.getBoundingClientRect(); return r.top<(window.innerHeight+600)&&r.bottom>-600; }
    if(near()){ init(root); return; } if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ io.disconnect(); init(root); } });},{rootMargin:'400px'}); io.observe(root); } else init(root);
    var on=function(){ if(near()){ window.removeEventListener('scroll',on); init(root); } }; window.addEventListener('scroll',on,{passive:true}); }
  function boot(){ document.querySelectorAll('[data-rx-bath]').forEach(arm); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
